import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  strategicAxis: Boundaries["removeStrategicAxis"]["request"],
): State {
  const index = state.findIndex(
    (req) => req.strategicAxis.uuid === strategicAxis.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { strategicAxis, request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { strategicAxis, request: setRequestStateToPending() }];
}

function handleSuccess(
  state: State,
  strategicAxis: Boundaries["removeStrategicAxis"]["success"],
): State {
  const index = state.findIndex(
    (req) => req.strategicAxis.uuid === strategicAxis.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { strategicAxis, request: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [...state, { strategicAxis, request: setRequestStateToSuccess() }];
}

function handleFailure(
  state: State,
  strategicAxis: Boundaries["removeStrategicAxis"]["failure"],
): State {
  const index = state.findIndex(
    (req) => req.strategicAxis.uuid === strategicAxis.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { strategicAxis, request: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [...state, { strategicAxis, request: setRequestStateToFailure() }];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.removeStrategicAxisRequested]: handleRequest,
    [events.removeStrategicAxisSucceeded]: handleSuccess,
    [events.removeStrategicAxisFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
